<template>
  <div >
    <div class="d-flex justify-content-end mb-5">
      <ButtonDropdownFilter
          btnClass=" h-35px"
          :btn-title="$t('expenses.label.allStatus')"
          :search="false"
          :options="eventInscriptionStatus"
          value-field="value"
          :name-field="locale"
          v-model="query.status"
      />
      <Button v-if="$can(abilities.CAN_ADD_SUBSCRIPTOR_TO_EVENT)" 
            type="new"
            @click.prevent="goToInscription"
            btn-class="btn-sm me-2" btn-text="events.participator.register" />
    </div> 
    <div class="table-responsive table-fix-head row" id="scrollable-list-container" style="max-height: 400px!important;">
      <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" >
        <thead>
        <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
          <th class="min-w-100px text-center">{{ $t('events.label.fullName') }}</th>
          <th class="min-w-100px text-center">{{ $t('events.label.email') }}</th>
          <th class="min-w-100px text-center">{{ $t('events.label.phone') }}</th>
          <th class="min-w-100px text-center">{{ $t('events.label.status') }} </th>
          <th class="min-w-100px text-center">{{ $t('events.label.inscriptionNumber') }}</th>
          <th class="min-w-100px text-center">{{ $t('events.label.date') }}</th>
          <th class="min-w-100px text-center">{{ $t('label.action') }}</th>
        </tr>
        </thead>
        <tbody v-if="isLoading && !inscriptions.length">
        <tr>
          <td colspan="7">
            <div class="h-200px d-flex justify-content-center align-items-center">
              <div class="text-center">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">{{ $t("loadingText") }}</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
        <tbody v-else-if="!inscriptions.length">
        <tr>
          <td colspan="7">
            <div class="h-300px d-flex justify-content-center align-items-center" >
              <div class=" text-center ">
                <div class="pt-8 ">
                  <Img filename="empty.png" alt=""
                      class="mw-100 h-125px h-sm-175px" />
                </div>
                <h2 class="fs-2x fw-bolder mb-0">{{ $t('expense.noData') }}</h2>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <template v-for="(inscription, index) in inscriptions" :key="index">
          <tr>
            <td class="dt-center text-center clickable"> {{ inscription.firstname }} {{ inscription.lastname }} </td>
            <td class="dt-center text-center clickable"> {{ inscription.email }}  </td>
            <td class="dt-center text-center clickable">
              {{ inscription.phone_code }} {{ inscription.phone }}
            </td>
            <td class="dt-center text-center clickable">
              <span class="badge" :class="'badge-'+inscription.status_formatted.color" > {{ inscription.status_formatted[locale] }}  </span>
            </td>
            <td class="dt-center text-center clickable">
              <span class="badge badge-primary"> {{ inscription.number.toString().padStart(2, '0') }} </span>
            </td>
            <td class="dt-center text-center clickable"> {{ new Date(inscription.created_at)?.toLocaleDateString() }} </td>
            <td class="dt-center text-center clickable">
              <div class="d-flex justify-content-center">
                <a v-if="inscription.status === inscriptionStatus.UNVALIDATED && $can(abilities.CAN_APPROVE_EVENT_SUBSCRIPTOR)" href="#" class="btn btn-sm btn-clean btn-icon" :title="$t('button.relance_last')" @click.prevent="sendLastRelanceInvitationMail(inscription.id)"> <i class="fas fa-paper-plane fs-2"></i> </a>
                <a v-if="inscription.status === inscriptionStatus.UNVALIDATED && $can(abilities.CAN_APPROVE_EVENT_SUBSCRIPTOR)" href="#" class="btn btn-sm btn-clean btn-icon" :title="$t('button.relance_first')" @click.prevent="sendFirstRelanceInvitationMail(inscription.id)"> <i class="fas fa-paper-plane fs-2"></i> </a>
                <a v-if="inscription.status === inscriptionStatus.UNVALIDATED && $can(abilities.CAN_APPROVE_EVENT_SUBSCRIPTOR)" href="#" class="btn btn-sm btn-clean btn-icon" :title="$t('button.show')" @click.prevent="reSendInvitationMail(inscription.id)"> <i class="fas fa-paper-plane fs-2"></i> </a>
                
                <a href="#" v-if="$can(abilities.CAN_VIEW_EVENT_SUBSCRIPTOR)" class="btn btn-sm btn-clean btn-icon" :title="$t('button.show')" @click.prevent="showInscriptionDetailModal(inscription?.detail_id ?? inscription.id)"> <i class="fas fa-eye fs-2"></i> </a>
                
                <a v-if="inscription.status === inscriptionStatus.UNVALIDATED && $can(abilities.CAN_APPROVE_EVENT_SUBSCRIPTOR)" href="#" class="btn btn-sm btn-clean btn-icon" :title="$t('button.show')" @click.prevent="approveEventInscription(inscription.id)"> <i class="fas fa fa-thumbs-up fs-2"></i> </a>
                <a v-if="inscription.status === inscriptionStatus.UNVALIDATED && $can(abilities.CAN_REJECT_EVENT_SUBSCRIPTOR)" href="#" class="btn btn-sm btn-clean btn-icon" :title="$t('button.edit')" @click.prevent="rejectEventInscription(inscription.id)"> <i class="fas fa-times fs-2"></i> </a>
              </div>
            </td>
          </tr>
        </template>
        <tr v-show="isLoading">
          <td colspan="7">
            <div class="d-flex justify-content-center align-items-center">
              <div class="text-center">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">{{ $t("loadingText") }}</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <EventInscriptionDetailModal v-if="!isSenakponTenant" id="event_inscription_detail" :inscription="showDetailData" :eventName="event?.title"/>
  <SenakponInscriptionDetailModal v-if="isSenakponTenant" id="event_inscription_detail" :inscriptionId="showDetailData" :eventName ="event?.title"/>
  <ApproveEventInscriptionModal id="approve_event_inscription" :data="formApproveData" :callback="reloadData" />
  <RejectEventInscriptionModal id="reject_event_inscription" :data="formRejectData" :callback="reloadData" />

</template>

<script setup>
import {computed, onMounted, reactive, ref, watch} from "vue";
import i18n from "@/plugins/i18n";
import {useLocales} from "@/composables/locales";
import {useSwal} from "@/composables/useSwal";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import Img from "@/components/Img.vue";
import {useEventEnums} from "@/Modules/Events/composables/eventTypes";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
import Button from "@/components/Button.vue";
import abilities from "@/composables/abilities";
import RejectEventInscriptionModal from "@/Modules/Events/components/modals/RejectEventInscriptionModal.vue";
import ApproveEventInscriptionModal from "@/Modules/Events/components/modals/ApproveEventInscriptionModal.vue";
import EventInscriptionDetailModal from "@/Modules/Events/components/modals/EventInscriptionDetailModal.vue"
import {resendInvitationMail} from "@/Modules/Events/store/modules/events/actions";
import { getTenantId } from "@/mixins/Helpers";
import SenakponInscriptionDetailModal from "@/Modules/Events/components/modals/SenakponInscriptionDetailModal.vue";

const store = useStore()
const route = useRoute()
const router = useRouter()
const {locale} = useLocales()
const {showSwal} = useSwal()
const { inscriptionStatus } = useEventEnums()

const emits = defineEmits(['reload'])

const query = ref({
  status: '',
})
const isLoading = ref(false)
const loading = ref(false)
const inscriptions = ref([])
const inscriptionsMetaData = reactive({
  current_page: 1,
  last_page: 1,
  next_page: null
})
const formApproveData = ref({
  event_inscription_id: "",
  status_id: "",
  rejection_motif: '',
})
const formRejectData = ref({
  event_inscription_id: "",
  status: "",
  status_id: "",
  rejection_motif: '',
})
const showDetailData = ref("")
const isSenakponTenant = ref(false)


const eventInscriptionStatus = computed(() => store.getters['events/getInscriptionStatusEnum'])
const event = computed(() => store.getters['events/getCurrentEvent'])

watch(() => query.value.status, (newValue) => {
  loadEventInscriptions(true)
})

watch(() => route.query.tab, (value) => {
    if(value){
        loadData()
    }
})

const loadNextPage = () => {
  const container = document.getElementById('scrollable-list-container');

  if(container) {
    container.addEventListener('scroll', () => {
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 50) {
        if (!isLoading.value) {
          if(inscriptionsMetaData.current_page < inscriptionsMetaData.last_page){
            loadEventInscriptions(false, inscriptionsMetaData.current_page + 1);
          }
        }
      }
    });
  }

};

function loadEventInscriptions(restart = false, page = null) {
  isLoading.value = true
  let filter = `?status=${query.value.status}`
  if(page) filter += `&page=${page}`
  store.dispatch('events/loadEventInscriptionRequest', {eventId: route.params.id, filter})
      .then(res => {
        if(!inscriptions.value.length || restart) {
          inscriptionsMetaData.current_page = res.data.current_page
          inscriptionsMetaData.last_page = res.data.last_page
          inscriptionsMetaData.next_page = res.data.next_page
          inscriptions.value = Array.isArray(res.data.data) ? res.data.data : Object.values(res.data.data)
          return;
        }
        inscriptionsMetaData.current_page = res.data.current_page
        inscriptionsMetaData.last_page = res.data.last_page
        inscriptionsMetaData.next_page = res.data.next_page
        const data = Array.isArray(res.data.data) ? res.data.data : Object.values(res.data.data)
        inscriptions.value = inscriptions.value.concat(data)
      }).finally(() => isLoading.value = false)
}

function showInscriptionDetailModal(id) {
  showDetailData.value = id
  $('#event_inscription_detail').modal('toggle')
}

function approveEventInscription (id) {
  showSwal(
      i18n.global.t('alert.approve_inscription'),
      i18n.global.t('alert.approve_inscription_text')
  ).then( async (result) => {
    if (result.value) {
      if (result.value) {
        formApproveData.value = {
          event_inscription_id: id,
          status: inscriptionStatus.value.APPROVED,
          status_id: '',
        }
        $("#approve_event_inscription").modal('toggle');
      }
    }
  })
}

function rejectEventInscription(id) {
  showSwal(
      i18n.global.t('alert.reject_inscription'),
      i18n.global.t('alert.reject_incription_text')
  ).then( async (result) => {
    if (result.value) {
      formRejectData.value = {
        event_inscription_id: id,
        status: inscriptionStatus.value.REJECTED,
        rejection_motif: '',
      }
      $("#reject_event_inscription").modal('toggle');
    }
  })
}

function reSendInvitationMail (id) {
  showSwal(
      i18n.global.t('events.swal.resend_invitation_mail'),
      i18n.global.t('events.swal.resend_invitation_mail_text')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('events/resendInvitationMail', id)
          .then(res => {

          })
          .catch(err => {

          })
    }
  })
}

function reloadData() {
  loadEventInscriptions(true)
  emits('reload')
}

function loadData() {
  if(route.query.tab === 'tab-subscriptions'){
    Promise.all([
      store.dispatch('events/loadEventInscriptionStatus'),
      loadEventInscriptions(),
      loadNextPage()
    ])
  }
}

function goToInscription(){
  router.push({name: "events-register", params:{id: route.params.id}})
}

 onMounted(() => {
    loadData()
    isSenakponTenant.value = getTenantId()?.slice(0, -1).toLowerCase() === 'senakpon'
  })

</script>

<style scoped>
  .card-header {
    padding-bottom: 0;
  }

  .nav.nav-line-tabs {
    align-items: flex-end;
    height: 100%;
  }

  .nav-line-tabs.nav-line-tabs-2x .nav-item {
    margin-bottom: -8px;
  }

  .nav-line-tabs .nav-item {
    height: 100%;
    display: flex;
    align-items: flex-end;
  }

  .nav-line-tabs .nav-link {
    border-bottom: 2px solid transparent;
    padding-bottom: 15px; 
  }

</style>